import { render, staticRenderFns } from "./Futuro.vue?vue&type=template&id=1ede3377&scoped=true"
import script from "./Futuro.vue?vue&type=script&lang=js"
export * from "./Futuro.vue?vue&type=script&lang=js"
import style0 from "../apply-step.css?vue&type=style&index=0&id=1ede3377&prod&scoped=true&lang=css&external"
import style1 from "./Futuro.vue?vue&type=style&index=1&id=1ede3377&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede3377",
  null
  
)

export default component.exports